import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

/** Je li nalog otvoren (vozilo još nije preuzeto) ili zatvoren. */
export const SERVICE_OPEN_OPTIONS: DropdownOption[] = [
  { value: "true", text: "Otvoreni nalozi" },
  { value: "false", text: "Zatvoreni nalozi" },
];

/** Boja statusa naloga iz baze → hex, za kružić uz status u dropdownu. Iste boje nosi i značka statusa u tablici. */
export const SERVICE_STATUS_HEX: Record<string, string> = {
  orange: "#f97316",
  blue: "#3b82f6",
  green: "#22c55e",
  slate: "#64748b",
};

export const DEFAULT_SERVICE_STATUS_HEX = "#64748b";
